export const getKeyFromValue = ({ value, obj }) => {
    for (const key in obj) {
        if (value === obj[key]) return key;
    }

    return '';
};
